export default {"src":"/_next/static/media/ico_coupon.980d51fb.svg","height":13,"width":15,"blurWidth":0,"blurHeight":0};